import React from 'react';

export const partners = [
	{
		data: (
			<>
				&mdash;&nbsp;ПАО&nbsp;&laquo;Уральский банк реконструкции и развития&raquo;, ул. 8 Марта, д. 51, эт. 11,
				г. Екатеринбург, 620063, ИНН 6608008004, ОГРН 1026600000350
			</>
		),
		id: 'rekonstruksciiuralbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО КБ&nbsp;&laquo;Центр-инвест&raquo;, проспект Соколова, 62, г. Ростов-на-Дону, Россия,
				344000, ИНН 6163011391, ОГРН 1026100001949
			</>
		),
		id: 'centrinvest',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО АКБ &laquo;Металлинвестбанк&raquo;&nbsp;&mdash; ул. Большая Полянка, д.&nbsp;47,
				стр.&nbsp;2, г. Москва, 119180, ИНН 7709138570, ОГРН 1027700218666
			</>
		),
		id: 'metallinvestbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;&laquo;Азиатско-Тихоокеанский Банк&raquo; (АО)&nbsp;&mdash; ул. Амурская, д.&nbsp;225, г.
				Благовещенск, 675004, ИНН 2801023444, ОГРН 1022800000079
			</>
		),
		id: 'atb',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;АК&nbsp;БАРС&raquo; БАНК&nbsp;&mdash; ул. Декабристов, д.&nbsp;1, г. Казань,
				Республика Татарстан, 420066, ИНН 1653001805, ОГРН 1021600000124
			</>
		),
		id: 'akbars',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО КБЭР &laquo;Банк Казани&raquo;&nbsp;&mdash; ул. Солдатская, д.1, г. Казань, 420066, ИНН
				1653018661, ОГРН 1021600000014
			</>
		),
		id: 'kazanbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО Банк Синара&nbsp;&mdash; ул. Куйбышева, д.&nbsp;75, г. Екатеринбург, 620026, ИНН
				6608003052, ОГРН 1026600000460
			</>
		),
		id: 'sinara',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;Банк ДОМ.РФ&raquo;&nbsp;&mdash; ул. Воздвиженка, д.&nbsp;10, г. Москва,
				125009, ИНН 7725038124, ОГРН 1037739527077
			</>
		),
		id: 'domrf',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;МОСКОВСКИЙ КРЕДИТНЫЙ БАНК&raquo;&nbsp;&mdash; Луков переулок, д.&nbsp;2,
				стр.&nbsp;1, г. Москва, 107045, ИНН 7734202860, ОГРН 1027739555282
			</>
		),
		id: 'mkb',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ТКБ БАНК ПАО&nbsp;&mdash; ул. Воронцовская, д. 27/35, г. Москва, 109147, ИНН 7709129705,
				ОГРН 1027739186970
			</>
		),
		id: 'tkb',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО &laquo;ТБанк&raquo; (правопреемник ПАО &laquo;РОСБАНК&raquo;) &mdash; ул. 2-я Хуторская,
				д. 38А, стр. 26, Москва, 127287, ИНН 7710140679 ОГРН 1027739642281
			</>
		),
		id: 'tbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;Банк &laquo;РЕСО Кредит&raquo; (АО)&nbsp;&mdash; шоссе Воробьевское, д. 6, г.
				Москва,119285, ИНН 7750004305, ОГРН 1087711000046
			</>
		),
		id: 'resokredit',
	},
	{
		data: (
			<>
				&mdash;&nbsp;КБ &laquo;ЛOKO-Банк&raquo; (АО)&nbsp;&mdash; Ленинградский проспект, д. 39, стр. 80, г.
				Москва, 125167, ИНН 7750003943, ОГРН 1057711014195
			</>
		),
		id: 'loko',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;Камкомбанк&raquo; (АО)&nbsp;&mdash; ул. Гидростроителей, д. 21, г. Набережные
				Челны, Республика Татарстан, 423800, ИНН 1650025163, ОГРН 1021600000840
			</>
		),
		id: 'kamkombank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;Промсвязьбанк&raquo;&nbsp;&mdash; ул. Смирновская, д. 10, строение 22, г.
				Москва, 109052, ИНН 7744000912, ОГРН 1027739019142
			</>
		),
		id: 'psb',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;Норвик Банк&raquo;&nbsp;&mdash; ул Зацепский Вал, д. 5, г. Москва, 115054, ИНН
				4346001485, ОГРН 1024300004739
			</>
		),
		id: 'norvik',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО &laquo;Свой Банк&raquo;&nbsp;&mdash; ул. Василисы Кожиной, д.&nbsp;1, г. Москва, 121096,
				ИНН 6453031840, ОГРН 1026400001870
			</>
		),
		id: 'svoibank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО &laquo;НС&nbsp;Банк&raquo;&nbsp;&mdash; ул. Добровольческая, д.&nbsp;20, стр.&nbsp;2, г.
				Москва, 109004, ИНН 7744001024, ОГРН 1027739198200
			</>
		),
		id: 'nsbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;КБ&nbsp;&laquo;Энерготрансбанк&raquo; (АО)&nbsp;&mdash; ул. Клиническая, 83а, Калининград,
				236016, ИНН 3906098008, ОГРН 1023900000080
			</>
		),
		id: 'etb',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО Социальный коммерческий банк Приморья &laquo;Примсоцбанк&raquo;&nbsp;&mdash; Приморский
				край, г. Владивосток, Партизанский пр-т, Д. 44, 690106. ИНН 2539013067, ОГРН 1022500001061
			</>
		),
		id: 'primsots',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МИКРОФИНАНСОВАЯ КОМПАНИЯ &laquo;ЗАЙМ ОНЛАЙН&raquo;&nbsp;&mdash; ул.&nbsp;8&nbsp;Марта,
				д.&nbsp;1&nbsp;стр.&nbsp;12, эт/пом/ком 10/LVI/2-7, г. Москва, 127083, ИНН 7703769314, ОГРН
				1127746428171
			</>
		),
		id: 'zaymonline',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;ИНТЕРПРОГРЕССБАНК&raquo;&nbsp;&mdash; Старокаширское шоссе, дом&nbsp;2,
				корпус&nbsp;1, строение&nbsp;1, г. Москва, 115201, ИНН 7724096412, ОГРН 1027739065375
			</>
		),
		id: 'interprogressbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО Микрокредитная компания &laquo;Кэшмагнит&raquo;&nbsp;&mdash; ул.&nbsp;Романова,
				д.&nbsp;25, Новосибирск, 630099, ИНН 5406808020, ОГРН 1205400040757
			</>
		),
		id: 'kashmagnit',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;СДМ-БАНК&raquo;&nbsp;&mdash; г. Москва, Волоколамское&nbsp;ш., д.73, 125424. ИНН
				7733043350, ОГРН 1027739296584
			</>
		),
		id: 'sdm',
	},
	{
		data: (
			<>
				&mdash;&nbsp;&laquo;МОРCКОЙ БАНК&raquo; (АО) &mdash; 117105&nbsp;г. Москва, Варшавское шоссе, д. 1А,
				помещение 1/5 . ИНН 7714060199, ОГРН 1027700568224
			</>
		),
		id: 'morskoi',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;БыстроБанк&raquo;&nbsp;&mdash; 426008, Удмуртская Республика, г.Ижевск,
				ул.Пушкинская, д.&nbsp;268. ИНН 1831002591, ОГРН 1021800001508
			</>
		),
		id: 'bystrobank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;МФК &laquo;Лайм-Займ&raquo; (ООО)&nbsp;&mdash; 630102, Новосибирская область, город
				Новосибирск, ул. Кирова, д.&nbsp;48, офис 1401. ИНН 7724889891, ОГРН 1137746831606
			</>
		),
		id: 'lime-zaim',
	},
	{
		data: (
			<>
				&mdash;&nbsp;Фастмани МКК (ООО)&nbsp;&mdash; 198217, г. Санкт-Петербург, бульвар Новаторов, д.&nbsp;108,
				лит.А, пом. 4Н, ИНН 7805714988, ОГРН 1177847323741
			</>
		),
		id: 'fastmoney',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;А&nbsp;ДЕНЬГИ&raquo;&nbsp;&mdash; 107078, РФ, Г.Москва, вн.тер.г.
				Муниципальный округ Красносельский, ул. Маши Порываевой, д.&nbsp;7, стр. А, этаж/помещ./ком.
				8/5-6Б/805-806, ИНН 7708400979, ОГРН 1217700636944
			</>
		),
		id: 'amoney',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МФК &laquo;Мани Мен&raquo;&nbsp;&mdash; 121096, г. Москва, ул. Василисы Кожиной, д.1,
				офис Д13&nbsp;ИНН 7704784072&nbsp;ОГРН 1117746442670
			</>
		),
		id: 'moneyman',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АКБ &laquo;Ноосфера&raquo;&nbsp;&mdash; 141109, РФ, Московская Область, г.о. Щёлково,
				г&nbsp;Щёлково, ул.&nbsp;Талсинская, д. 59, стр. 3А, ИНН 0411006129, ОГРН 1020400000059
			</>
		),
		id: 'noosfera',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;Кредит Европа Банк (Россия)&raquo;&nbsp;&mdash; 129090, г. Москва,
				Олимпийский пр-кт, д. 14, ОГРН 1037739326063, ИНН 7705148464
			</>
		),
		id: 'keb',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МФК &laquo;ЭкспрессДеньги&raquo;&nbsp;&mdash; 424038, Республика Марий&nbsp;Эл, г.
				Йошкар-ола, б-р Чайвана, Д. 12А, ИНН 1215150103, ОГРН 1101215004593
			</>
		),
		id: 'expressmoney',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Срочноденьги&raquo;&nbsp;&mdash; 603022, Нижегородская область, г.о. город
				Нижний Новгород, г. Нижний Новгород, ул. Тимирязева, д.&nbsp;15, к.&nbsp;2, помещ. П406&nbsp;ИНН
				5260271530&nbsp;ОГРН 1105260001857
			</>
		),
		id: 'srochnodengi',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;ЛАЙК МАНИ&raquo;&nbsp;&mdash; 603022, Нижегородская область, г. Нижний
				Новгород, ул. Тимирязева, д.&nbsp;15, корп.&nbsp;2, помещ. П42&nbsp;ИНН 5262398074&nbsp;ОГРН
				1255200003552
			</>
		),
		id: 'likemoney',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;СМСФИНАНС&raquo; &minus;125130, Г.МОСКВА,ПР-Д СТАРОПЕТРОВСКИЙ, Д. 7А, СТР
				25, ЭТ&nbsp;3&nbsp;ПОМ 8, ИНН 7724351447, ОГРН 1167746117483
			</>
		),
		id: 'smsfinance',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;ТУРБОЗАЙМ&raquo;&nbsp;&mdash; 121087, г. Москва, вн.тер.г. муниципальный
				округ Филевский парк, ул. Барклая, д.&nbsp;6, стр.&nbsp;5, помещ. 23П/4, ИНН 7702820127, ОГРН
				1137746702367
			</>
		),
		id: 'turbozaim',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО ФИНСТАР БАНК&nbsp;&mdash; 196084, г. Санкт-Петербург, ул. Черниговская, д.&nbsp;8, лит.
				А, пом. 1-Н, ИНН 2465037737, ОГРН 1022400003944
			</>
		),
		id: 'finstarbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;СК&nbsp;&laquo;Ренессанс Жизнь&raquo;&nbsp;&mdash; 121614, РФ, г. Москва, вн.
				тер.&nbsp;г. муниципальный округ Крылатское, ул. Крылатская, д.&nbsp;17, к.&nbsp;1, ИНН 7725520440 ,
				ОГРН 1047796714404
			</>
		),
		id: 'renessans-life',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;ОТП Банк&raquo;&nbsp;&mdash; 1125171, РФ, г. Москва, Ленинградское шоссе, д.
				16А, стр. 2, ИНН 7708001614, ОГРН 1027739176563
			</>
		),
		id: 'otp-bank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО&nbsp;МКК Триумвират&nbsp;&mdash; 121087, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ФИЛЕВСКИЙ ПАРК, УЛ БАРКЛАЯ, Д. 6, СТР. 5, ПОМЕЩ. 23В/3, ИНН 7743384078, ОГРН 1227700365815
			</>
		),
		id: 'triumvirat',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО&nbsp;МКК Чистый лист&nbsp;&mdash; 121087, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ФИЛЕВСКИЙ ПАРК, УЛ БАРКЛАЯ, Д. 6, СТР. 5, ПОМЕЩ. 23В/3, ИНН 9723146336, ОГРН 1227700180729
			</>
		),
		id: 'chistiy-list',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО&nbsp;МКК Денежная крепость&nbsp;&mdash; 121087, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ФИЛЕВСКИЙ ПАРК, УЛ БАРКЛАЯ, Д. 6, СТР. 5, ПОМЕЩ. 23В/3 , ИНН 9728088938, ОГРН 1237700140182
			</>
		),
		id: 'denezhnaya-krepost',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО&nbsp;МКК ЦФП&nbsp;&mdash; 117218, г. Москва, вн.тер.г. муниципальный округ Котловка,
				ул. Кржижановского, д. 29 к. 5, помещ. I, ком. 10, ИНН 7727480641, ОГРН 1217700621709
			</>
		),
		id: 'cfp',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК Эквазайм&nbsp;&mdash; 432071, Ульяновская область, г.о. город Ульяновск, г.
				Ульяновск, ул. Карла Маркса, д. 13А, к.&nbsp;1, помещ./этаж 32/3, ИНН 7300032408, ОГРН 1247300004380
			</>
		),
		id: 'ekvazaim',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МФК МигКредит&nbsp;&mdash; 127015, город Москва, Большая Новодмитровская&nbsp;ул,
				д.&nbsp;23&nbsp;стр.&nbsp;3, помещ. 1/7, ИНН 7715825027, ОГРН 1107746671207
			</>
		),
		id: 'migcredit',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МФК &laquo;ВЭББАНКИР&raquo;&nbsp;&mdash; 125627, РФ, г. Москва,
				УЛ&nbsp;СОКОЛОВО-МЕЩЕРСКАЯ, Д. 29, ОФИС 308 , ИНН 7733812126, ОГРН 1127746630846
			</>
		),
		id: 'webbankir',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;РУСИНТЕРФИНАНС&raquo;&nbsp;&mdash; 630055, ОБЛАСТЬ НОВОСИБИРСКАЯ.&nbsp;Г.
				НОВОСИБИРСК, УЛ. ГНЕСИНЫХ, Д.10/1, ОФИС 202, ИНН 5408292849, ОГРН 1125476023298
			</>
		),
		id: 'rusinterfinance',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;Банк Жилищного Финансирования&raquo;, 121357, г. Москва, ул. Верейская,
				д.&nbsp;29, стр.&nbsp;134, ИНН 7709056550, ОГРН 1027739098639
			</>
		),
		id: 'bzhf',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;РЕАЛИСТ БАНК&raquo;, 109004, г. Москва, ул. Станиславского, дом&nbsp;4,
				строение&nbsp;1, ИНН 3801002781, ОГРН 1023800000124
			</>
		),
		id: 'realistbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;&laquo;Банк Русский Стандарт&raquo;, 105187, г. Москва, ул. Ткацкая, д.&nbsp;36,
				ИНН 7707056547, ОГРН 1027739210630
			</>
		),
		id: 'russtandartbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Джой мани&raquo;&nbsp;&mdash; 630099, Новосибирская область, г. Новосибирск,
				ул. Советская, д.&nbsp;12, 4 этаж, ИНН 5407496776 ОГРН 1145476064711
			</>
		),
		id: 'joymoney',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО&nbsp;МКК &laquo;Займ-Экспресс&raquo;, 125315, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				СОКОЛ, ПР-КТ ЛЕНИНГРАДСКИЙ, Д. 80, К. 9, ИНН 9703154018, ОГРН 1237700573175
			</>
		),
		id: 'express-zaim',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО&nbsp;&laquo;МТС банк&raquo;, 115432, г. Москва, Проспект Андропова, д.&nbsp;18,
				корп.&nbsp;1, ИНН 7702045051, ОГРН 1027739053704
			</>
		),
		id: 'mtsbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;СМЛТ БАНК&raquo;, 121096, г. Москва, вн.тер.&nbsp;округ Филевский парк, ул.
				Василисы Кожиной, д.&nbsp;1, этаж&nbsp;1, комнаты&nbsp;1&ndash;30, ИНН 7705003797, ОГРН 1027739919954
			</>
		),
		id: 'smltbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МК&nbsp;&laquo;Хурма Кредит&raquo;&nbsp;&mdash; 603022, Нижегородская область,
				г.&nbsp;Нижний Новгород, ул.&nbsp;Окский Съезд, д.&nbsp;8, пом.&nbsp;П3, офис&nbsp;103, ИНН 5262390614,
				ОГРН 1235200008240
			</>
		),
		id: 'hurma-credit',
	},
	{
		data: (
			<>
				&mdash;&nbsp;КПК &laquo;Фонд Ипотечного Кредитования&raquo;&nbsp;&mdash; 620000, Свердловская область,
				г.&nbsp;Екатеринбург, ул.&nbsp;Малышева, стр.&nbsp;51, офис&nbsp;26/14, ИНН 6678102434, ОГРН
				1196658040677
			</>
		),
		id: 'fond-ipotechnogo-kreditovaniya',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;Совкомбанк&raquo;, 156000, Российская Федерация, Костромская обл., г. Кострома,
				проспект Текстильщиков, д. 46
			</>
		),
		id: 'sovcombank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;МКК НОВОЕ ФИНАНСИРОВАНИЕ&raquo;, 344034, Ростовская область, г. Ростов-на-Дону,
				ул. Портовая, д. 193, офис 310, ИНН 6162073437, ОГРН 1166196099057
			</>
		),
		id: 'novoe-finansirovanie',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;МКК БериБеру&raquo;&nbsp;&mdash; 603093, Нижегородская область, г.&nbsp;Нижний
				Новгород, ул.&nbsp;Ковровская, д.&nbsp;21А, помещ.&nbsp;501, ИНН 1657270975 ОГРН 1211600072342
			</>
		),
		id: 'beriberu',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;ДоброЗайм Быстрое решение&raquo;&nbsp;&mdash; 123007, г.&nbsp;Москва,
				Хорошёвское шоссе, дом&nbsp;35, корпус&nbsp;1, помещение&nbsp;20А.22, ИНН 7725850061 ОГРН 5147746405637
			</>
		),
		id: 'dobrozaim-bystroe-reshenie',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО МФК &laquo;Саммит&raquo;&nbsp;&mdash; 123007, г.&nbsp;Москва, Хорошёвское шоссе,
				дом&nbsp;35, корпус&nbsp;1, ИНН 9714073258 ОГРН 1257700155360
			</>
		),
		id: 'sammit',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Кредиска&raquo;&nbsp;&mdash; 603093, РФ, Нижегородская область,
				г.&nbsp;Нижний Новгород, ул.&nbsp;Ковровская, д.&nbsp;21А, помещ.&nbsp;504, ИНН 5262378712 ОГРН
				1215200013170
			</>
		),
		id: 'krediska',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Да-Кредит&raquo;&nbsp;&mdash; 603022, Нижегородская область, г.&nbsp;Нижний
				Новгород, ул.&nbsp;Окский Съезд, д.&nbsp;8, пом.&nbsp;П3, офис&nbsp;302, ИНН 5262392883 ОГРН
				1235200029107
			</>
		),
		id: 'da-kredit',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;АльфаСтрахование-Жизнь&raquo;, 115280, г.&nbsp;Москва, вн.тер.г. муниципальный
				округ Даниловский, пр-кт Лихачёва, д.&nbsp;15, помещ.&nbsp;2/10, ИНН 7715228310 ОГРН 1027739301050
			</>
		),
		id: 'alfastrakhovanie-zhizn',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ПАО &laquo;БАНК УРАЛСИБ&raquo;, 119048, г.&nbsp;Москва, ул.&nbsp;Ефремова, д.&nbsp;8, ИНН
				0274062111 ОГРН 1020280000190
			</>
		),
		id: 'uralsib',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО УК &laquo;ФИНСТАР КАПИТАЛ&raquo;, 123112, г.&nbsp;Москва, вн.тер.г. муниципальный округ
				Пресненский, наб.&nbsp;Пресненская, д.&nbsp;12, помещ.&nbsp;6/52. ИНН 9703154610, ОГРН 1237700591919
			</>
		),
		id: 'finstar-kapital',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;Блокчейн Хаб&raquo;, 119435, г.&nbsp;Москва, вн.тер.г. муниципальный округ
				Хамовники, пер.&nbsp;Большой Саввинский, д.&nbsp;8 стр.&nbsp;1, помещ.&nbsp;1П. ИНН 9704089611, ОГРН
				1217700447755
			</>
		),
		id: 'blockchain-hub',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;ВЭББАНКИР&raquo;, 143440, РФ, Московская область, городской округ
				Красногорск, поселок городского типа Путилково, территория Гринвуд, строение&nbsp;1, помещение&nbsp;144.
				ИНН 7736364137, ОГРН 1247700626370
			</>
		),
		id: 'webbankir-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Центрофинанс Групп&raquo;, 164514, Архангельская область,
				г.&nbsp;Северодвинск, ул.&nbsp;Карла Маркса, д.&nbsp;46, офис&nbsp;500. ИНН 2902076410, ОГРН
				1132932001674
			</>
		),
		id: 'centrofinans-grupp',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО ЦМРБанк&nbsp;&mdash; 127055, Российская Федерация, г.&nbsp;Москва, ул.&nbsp;Палиха,
				дом&nbsp;10, строение&nbsp;7. ИНН 7750056670, ОГРН 1157700005759
			</>
		),
		id: 'cmrbank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;МАНИ МЕН&raquo;&nbsp;&mdash; 123290, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ПРЕСНЕНСКИЙ, УЛ.&nbsp;ЕРМАКОВА РОЩА, Д.&nbsp;1, СТР.&nbsp;1, ПОМЕЩ.&nbsp;175Н. ИНН 7705974076, ОГРН
				5117746058172
			</>
		),
		id: 'manimen-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО &laquo;ДатаБанк&raquo;&nbsp;&mdash; 426076, Удмуртская Республика, г.&nbsp;Ижевск,
				ул.&nbsp;Ленина, д.&nbsp;30, ИНН 1835047032, ОГРН 1021800000090
			</>
		),
		id: 'databank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК Быстроденьги&nbsp;&mdash; 432071, Ульяновская область, г.о.&nbsp;город Ульяновск,
				г.&nbsp;Ульяновск, ул.&nbsp;Карла Маркса, д.&nbsp;13 А, к.&nbsp;1, этаж/помещ.&nbsp;3/5. ИНН 7300044749,
				ОГРН 1257300005863
			</>
		),
		id: 'bystrodengi-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МФК Быстроденьги&nbsp;&mdash; 121087, г.&nbsp;Москва, вн.тер.г.&nbsp;муниципальный
				округ Филевский парк, ул.&nbsp;Барклая, д.&nbsp;6, стр.&nbsp;5, помещ.&nbsp;23П/4. ИНН 7325081622, ОГРН
				1087325005899
			</>
		),
		id: 'bystrodengi-mfk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;М-ДЕНЬГИ&raquo;&nbsp;&mdash; 191187, Г.САНКТ-ПЕТЕРБУРГ, ВН.ТЕР.Г.
				МУНИЦИПАЛЬНЫЙ ОКРУГ ЛИТЕЙНЫЙ ОКРУГ, УЛ.&nbsp;ШПАЛЕРНАЯ, Д.&nbsp;8, ЛИТЕРА А, ПОМЕЩ.&nbsp;16-Н,
				КОМ.&nbsp;4. ИНН 9703151232, ОГРН 1237700493216
			</>
		),
		id: 'm-dengi-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;АО &laquo;Контрада Капитал&raquo;&nbsp;&mdash; 123022, г.&nbsp;Москва,
				вн.тер.г.&nbsp;муниципальный округ Пресненский, пер&nbsp;Столярный, д.&nbsp;3, к.&nbsp;14. ИНН
				9703206844, ОГРН 1257700107642
			</>
		),
		id: 'kontrada-kapital',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;КВИК МАНИ&raquo;&nbsp;&mdash; 125363, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ
				ОКРУГ ЮЖНОЕ ТУШИНО, Б-Р&nbsp;ЯНА РАЙНИСА, Д.&nbsp;5, ПОМЕЩ.&nbsp;2Ц. ИНН 7733466363, ОГРН 1257700155426
			</>
		),
		id: 'kvik-mani-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Русзаймсервис&raquo;&nbsp;&mdash; 115516, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ
				ОКРУГ ЦАРИЦЫНО, УЛ&nbsp;БЕХТЕРЕВА, Д.&nbsp;31, К.&nbsp;3, ПОМЕЩ.&nbsp;4П. ИНН 9717088848, ОГРН
				1197746729806
			</>
		),
		id: 'ruszaymservis-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО &laquo;ВБ Банк&raquo;&nbsp;&mdash; 119017, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ЯКИМАНКА, УЛ.&nbsp;БОЛЬШАЯ ОРДЫНКА, Д.&nbsp;40, СТР.&nbsp;4. ИНН 0102000578, ОГРН 1020100002340
			</>
		),
		id: 'vb-bank',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Лорд&raquo;&nbsp;&mdash; 129301, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				АЛЕКСЕЕВСКИЙ, УЛ&nbsp;БОРИСА ГАЛУШКИНА, Д.&nbsp;17, ПОМЕЩ.&nbsp;17/1. ИНН 9714049544, ОГРН 1247700365505
			</>
		),
		id: 'lord-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;ФЛЭШЗАЙМ&raquo;&nbsp;&mdash; 123103, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ХОРОШЕВО-МНЕВНИКИ, ПР-КТ&nbsp;МАРШАЛА ЖУКОВА, Д.&nbsp;76, К.&nbsp;2, ПОМЕЩ.&nbsp;5/1. ИНН 9723257075,
				ОГРН 1257700327940
			</>
		),
		id: 'fleshzaym-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Фрида&raquo;&nbsp;&mdash; 125047, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				ТВЕРСКОЙ, УЛ&nbsp;4-Я ТВЕРСКАЯ-ЯМСКАЯ, Д.&nbsp;2/11, СТР.&nbsp;2, ПОМЕЩ.&nbsp;2/П. ИНН 9722096146, ОГРН
				1257700161718
			</>
		),
		id: 'frida-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Ф ФИНАНС&raquo;&nbsp;&mdash; 121615, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				КУНЦЕВО, Ш.&nbsp;РУБЛЁВСКОЕ, Д.&nbsp;16, К.&nbsp;1, ПОМЕЩ.&nbsp;200. ИНН 9722101935, ОГРН 1257700315619
			</>
		),
		id: 'f-finans-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО СК &laquo;Гелиос&raquo;&nbsp;&mdash; 350015, КРАСНОДАРСКИЙ КРАЙ, Г.О.&nbsp;ГОРОД
				КРАСНОДАР, Г.&nbsp;КРАСНОДАР, УЛ.&nbsp;НОВОКУЗНЕЧНАЯ, Д.&nbsp;40, ОФИС&nbsp;68. ИНН 7705513090, ОГРН
				1047705036939
			</>
		),
		id: 'gelios-sk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Фемида&raquo;&nbsp;&mdash; 109052, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				НИЖЕГОРОДСКИЙ, УЛ&nbsp;СМИРНОВСКАЯ, Д.&nbsp;2, СТР.&nbsp;1, ПОМЕЩ.&nbsp;110А. ИНН 9722106468, ОГРН
				1257700431064
			</>
		),
		id: 'femida-mkk',
	},
	{
		data: (
			<>
				&mdash;&nbsp;ООО МКК &laquo;Гиацинт&raquo;&nbsp;&mdash; 111675, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ
				КОСИНО-УХТОМСКИЙ, УЛ&nbsp;СВЯТООЗЕРСКАЯ, Д.&nbsp;11, ПОМЕЩ.&nbsp;15/1. ИНН 7720947687, ОГРН
				1257700154337
			</>
		),
		id: 'giatsint-mkk',
	},
];
